<script setup lang="ts">
const socialTypeIcons: Record<string, string> = {
  linkedin: 'ri:linkedin-box-fill',
  email: 'material-symbols:alternate-email'
}

const directors = [
  {
    name: 'Budi Satria Isman',
    role: 'President Commissioner',
    image: '/images/director/Budi Isman_converted.webp',
    socials: [
      {
        type: 'linkedin',
        url: 'https://www.linkedin.com/in/budi-isman-7355048/'
      }
    ]
  },
  {
    name: 'Yulian Afrizal',
    role: 'Commissioner',
    image: '/images/director/Yulian Afrizal_converted.webp'
  },
  {
    name: 'Fariz GTJ',
    role: 'Chief Executive Officer',
    image: '/images/director/Fariz_converted.webp',
    socials: [
      {
        type: 'linkedin',
        url: 'https://www.linkedin.com/in/farizgtj/'
      },
      {
        type: 'email',
        url: 'mailto:fariz@kiriminaja.com'
      }
    ]
  },
  {
    name: 'Muhammad Irfan H',
    role: 'Chief Technology Officer',
    image: '/images/director/Jepon_converted.webp',
    socials: [
      {
        type: 'linkedin',
        url: 'https://www.linkedin.com/in/muhammad-ih-932b96125/'
      }
    ]
  },
  {
    name: 'Paras Nasution',
    role: 'Chief Operating Officer',
    image: '/images/director/Paras_converted.webp',
    socials: [
      {
        type: 'linkedin',
        url: 'https://www.linkedin.com/in/paras-m-nasution-121b524a/'
      }
    ]
  },
  {
    name: 'Oka Mahendra',
    role: 'Chief Financial Officer',
    image: '/images/director/Oka_converted.webp',
    socials: [
      {
        type: 'linkedin',
        url: 'https://www.linkedin.com/in/oka-mahendra-343326147/'
      }
    ]
  }
]

const headOfs = [
  {
    name: 'Khairunnisa Humairoh',
    role: 'VP Sales Development',
    image: '/images/director/Khairunnisa_converted.webp'
  },
  {
    name: 'Shandy Febiarisma',
    role: 'Head of Business Operation',
    image: '/images/director/Shandy_converted.webp',
    socials: [
      {
        type: 'linkedin',
        url: 'https://www.linkedin.com/in/shandy-febiarisma-b54b57240/'
      }
    ]
  },
  {
    name: 'Luluk Seilla',
    role: 'Sales Manager',
    image: '/images/director/Luluk_converted.webp',
    socials: [
      {
        type: 'linkedin',
        url: 'https://www.linkedin.com/in/luluk-s-7914a5137/'
      }
    ]
  },
  {
    name: 'Redhi',
    role: 'Marketing & Brand Manager',
    image: '/images/director/Redhi_converted.webp'
  },
  {
    name: 'Naning Fitriani',
    role: 'HRD Manager',
    image: '/images/director/Naning_converted.webp',
    socials: [
      {
        type: 'linkedin',
        url: 'https://www.linkedin.com/in/naning-fitriani-7078431b2/'
      }
    ]
  },
  {
    name: 'Ilham Hary Prayitno',
    role: 'Head of Engineer',
    image: '/images/director/Ilham_converted.webp',
    socials: [
      {
        type: 'linkedin',
        url: 'https://www.linkedin.com/in/ilham-hary-prayitno/'
      }
    ]
  },
  {
    name: 'Muhammad Army',
    role: 'Head of Product',
    image: '/images/director/Army_converted.webp'
  }
]

const combinedData = [directors, headOfs]
</script>
<template>
  <section class="py-10 lg:py-24">
    <UiContainer>
      <UiSectionTitle
        class="lg:max-w-11/12 text-center lg:mx-auto mb-10"
        title="Manajemen"
        variant-size="large"
        description="Bersama para ahli dan tenaga berpengalaman, kami berkomitmen agar terus berkembang <br/> melalui inovasi teknologi untuk memudahkan bisnis Sahabat KA."
      />

      <div
        class="grid grid-cols-2 lg:flex lg:flex-wrap lg:justify-center gap-4 min-[1024px]:gap-y-10 min-[1482px]:gap-y-0"
      >
        <template v-for="(combined, index) in combinedData" :key="index">
          <div
            v-for="(data, indexData) in combined"
            :key="indexData"
            class="group"
          >
            <div class="rounded-xl overflow-hidden relative lg:w-48 mb-2">
              <NuxtImg
                :src="data.image"
                :alt="data.name"
                class="w-full h-full aspect-square"
              />
              <div
                v-if="data.socials"
                class="absolute bottom-0 group-hover:bottom-3 left-3 flex gap-1.5 translate-y-full group-hover:translate-y-0 transition-transform"
              >
                <NuxtLink
                  v-for="(social, sIndex) in data.socials"
                  :key="sIndex"
                  :to="social.url"
                  target="_blank"
                  rel="nofollow"
                  class="inline-flex mt-2 border bg-background border-outline-variant hover:border-outline text-on-surface-variant rounded-lg p-1"
                  :aria-label="social.type"
                >
                  <Icon
                    :name="
                      socialTypeIcons[social.type] ?? 'material-symbols:link'
                    "
                    size="18px"
                  />
                </NuxtLink>
              </div>
            </div>
            <div class="text-sm">
              <h4 class="font-bold">{{ data.name }}</h4>
              <div class="text-on-surface-variant">{{ data.role }}</div>
            </div>
          </div>
          <div
            v-if="index === 0"
            class="hidden min-[1482px]:block basis-full h-10"
          ></div>
        </template>
      </div>
    </UiContainer>
  </section>
</template>
